import React, { useEffect } from "react";
import { getIdentityUrl, getRovoExtensionWebBaseUrl } from "../../../config";
import { ANALYTICS_SCREEN_NAMES, ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS } from "../../../analytics/analyticsEvents";
import { useSendAnalyticEvent } from "../../../analytics/analyticsClient";
import { clearSentryUser } from "../../../bootstrap/sentry";

export const IdentityLogout = (): React.JSX.Element => {
  const sendAnalyticEvent = useSendAnalyticEvent();

  useEffect(() => {
    const redirectToIdentity = (): void => {
      // https://data-portal.internal.atlassian.com/analytics/registry/74804
      sendAnalyticEvent({
        eventType: "track",
        event: {
          action: "initialised",
          actionSubject: ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS.LOGOUT,
          source: ANALYTICS_SCREEN_NAMES.EXTENSION_REDIRECT_TO_IDENTITY_SCREEN,
        },
        userId: "",
      });

      clearSentryUser();

      const IdentityLogoutUrl = getIdentityUrl() + "/logout";
      const IdentityLogOutUrlWithRedirect = `${IdentityLogoutUrl}?continue=${encodeURIComponent(getRovoExtensionWebBaseUrl() + "/extension/ntp-logout-redirect")}`;

      window.parent.location.href = IdentityLogOutUrlWithRedirect;
    };

    redirectToIdentity();
  }, [sendAnalyticEvent]);

  return <></>;
};
